import React from 'react';

/**
 * GradientSection - Refined section transitions
 * Uses the warm brand palette for subtle background gradients
 */
const GradientSection = ({
  children,
  variant = 'white',
  className = '',
  id = ''
}) => {
  const gradients = {
    'white': 'bg-white',
    'warm': 'bg-neutral-50',
    'gold': 'bg-gradient-to-b from-brand-50/50 to-white',
    'bronze': 'bg-gradient-to-b from-brand-100/30 to-white',
    'charcoal': 'bg-gradient-to-b from-neutral-100/50 to-white',

    'white-to-gold': 'bg-gradient-to-b from-white via-white to-brand-50/50',
    'gold-to-white': 'bg-gradient-to-b from-brand-50/50 via-white to-white',
    'gold-to-bronze': 'bg-gradient-to-b from-brand-50/50 via-brand-50/30 to-brand-100/30',
    'bronze-to-white': 'bg-gradient-to-b from-brand-100/30 via-white to-white',
    'white-to-charcoal': 'bg-gradient-to-b from-white via-neutral-50 to-neutral-100/50',
    'charcoal-to-white': 'bg-gradient-to-b from-neutral-100/50 via-neutral-50 to-white',

    'gold-bronze-white': 'bg-gradient-to-b from-brand-50/50 via-brand-100/30 to-white',
    'white-gold-bronze': 'bg-gradient-to-b from-white via-brand-50/50 to-brand-100/30',

    'hero-dark': 'bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-800',
    'cta-gold': 'bg-gradient-to-r from-brand-500 via-brand-400 to-brand-600',
  };

  const gradientClass = gradients[variant] || gradients['white'];

  return (
    <section
      id={id}
      className={`relative ${gradientClass} ${className}`}
    >
      {children}
    </section>
  );
};

export default GradientSection;
